<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <h5 style="font-size: 16px; color: #657383">Mailing Address</h5>
      </div>
      <!-- MAILING ADDRESS -->
      <div class="md-layout-item md-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('mAddress1') && touched.mailingAddress.address1 },
            { 'md-form-group': true },
            { 'md-error': errors.has('mAddress1') }
          ]"
        >
          <md-icon>location_on</md-icon>
          <label>Address</label>
          <md-input v-validate="'required'" v-model="mAddress1" data-vv-name="mAddress1" type="text" name="mAddress1" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('mAddress1')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('mAddress1') && touched.mailingAddress.address1" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('mCity') && touched.mailingAddress.city },
            { 'md-form-group': false },
            { 'md-error': errors.has('mCity') }
          ]"
        >
          <md-icon>location_city</md-icon>
          <label>City</label>
          <md-input v-validate="'required'" v-model="mCity" data-vv-name="mCity" type="text" name="mCity" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('mCity')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('mCity') && touched.mailingAddress.state" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div
        :class="[
          { 'md-layout-item': true },
          { 'space-right-phone': true },
          { 'md-size-40': isPhone },
          { 'md-size-30': !isPhone }
        ]"
        class="md-layout-item md-size-50 md-small-size-100"
        @click="focus('mState')"
      >
        <md-field
          :class="[
            { 'md-valid': !errors.has('mState') && touched.mailingAddress.state },
            { 'md-form-group': true },
            { 'md-error': errors.has('mState') }
          ]"
        >
          <md-icon>outlined_flag</md-icon>
          <label>State</label>
          <md-select
            v-validate="'required'"
            id="state-select"
            ref="stateInput"
            v-model="mState"
            style="margin-left: 20px"
            data-vv-name="mState"
            type="text"
            name="mState"
            md-dense
            @keydown.native="stateFind($event)"
          >
            <md-option
              v-for="(state, index) in states"
              :key="state.LookupId"
              :id="state + '-state'"
              :value="state.LookupId"
              :md-value="state"
              >{{ state.DisplayValue }}</md-option
            >
          </md-select>
          <slide-y-down-transition>
            <md-icon v-show="errors.has('mState')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('mState') && touched.mailingAddress.state" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('mZipCode') && touched.mailingAddress.zipCode },
            { 'md-form-group': false },
            { 'md-error': errors.has('mZipCode') }
          ]"
        >
          <md-icon>location_on</md-icon>
          <label class="spaced-phone-label">Zip-Code</label>
          <md-input
            v-validate="'required'"
            ref="zipCodeInput"
            v-model="mZipCode"
            data-vv-name="mZipCode"
            type="text"
            name="mZipCode"
          />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('mZipCode')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('mZipCode') && touched.mailingAddress.zipCode" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100" @click="focus('mCountry')">
        <md-field
          :class="[
            { 'md-valid': !errors.has('mCountry') && touched.mailingAddress.country },
            { 'md-form-group': false },
            { 'md-error': errors.has('mCountry') }
          ]"
        >
          <md-icon>outlined_flag</md-icon>
          <label>Country</label>
          <md-select
            v-validate="'required'"
            id="country-select"
            ref="countryInput"
            v-model="mCountry"
            data-vv-name="mCountry"
            type="text"
            name="mCountry"
            md-dense
          >
            <md-option v-for="(country, index) in countries" :key="index" :value="country.LookupId" :id="country"
              >{{ country.DisplayValue }}
            </md-option>
          </md-select>
          <slide-y-down-transition>
            <md-icon v-show="errors.has('mCountry')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('mCountry') && touched.mailingAddress.country" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <hr style="width: 100%; border-color: #1565c0; margin-top: 25px; margin-bottom: 20px" />
    </div>

    <!-- BILLING ADDRESS -->
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <h5 style="font-size: 16px; color: #657383">Billing Address</h5>
      </div>
      <div class="md-layout-item md-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('bAddress1') && touched.businessAddress.address1 },
            { 'md-form-group': true },
            { 'md-error': errors.has('bAddress1') }
          ]"
        >
          <md-icon>location_on</md-icon>
          <label>Address</label>
          <md-input v-validate="'required'" v-model="bAddress1" data-vv-name="bAddress1" type="text" name="bAddress1" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('bAddress1')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('bAddress1') && touched.businessAddress.address1" class="success"
              >done</md-icon
            >
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('bCity') && touched.businessAddress.city },
            { 'md-form-group': false },
            { 'md-error': errors.has('bCity') }
          ]"
        >
          <md-icon>location_city</md-icon>
          <label>City</label>
          <md-input v-validate="'required'" v-model="bCity" data-vv-name="bCity" type="text" name="bCity" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('bCity')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('bCity') && touched.businessAddress.state" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div
        :class="[
          { 'md-layout-item': true },
          { 'space-right-phone': true },
          { 'md-size-40': isPhone },
          { 'md-size-30': !isPhone }
        ]"
        class="md-layout-item md-size-50 md-small-size-100"
        @click="focus('bState')"
      >
        <md-field
          :class="[
            { 'md-valid': !errors.has('bState') && touched.businessAddress.state },
            { 'md-form-group': true },
            { 'md-error': errors.has('bState') }
          ]"
        >
          <md-icon>outlined_flag</md-icon>
          <label>State</label>
          <md-select
            v-validate="'required'"
            id="state-select"
            ref="stateInput"
            v-model="bState"
            style="margin-left: 20px"
            data-vv-name="bState"
            type="text"
            name="bState"
            md-dense
            @keydown.native="stateFind($event)"
          >
            <md-option
              v-for="(state, index) in states"
              :key="state.LookupId"
              :id="state + '-state'"
              :value="state.LookupId"
              :md-value="state"
              >{{ state.DisplayValue }}</md-option
            >
          </md-select>
          <slide-y-down-transition>
            <md-icon v-show="errors.has('bState')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('bState') && touched.businessAddress.state" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('bZipCode') && touched.businessAddress.zipCode },
            { 'md-form-group': false },
            { 'md-error': errors.has('bZipCode') }
          ]"
        >
          <md-icon>location_on</md-icon>
          <label class="spaced-phone-label">Zip-Code</label>
          <md-input
            v-validate="'required'"
            ref="zipCodeInput"
            v-model="bZipCode"
            data-vv-name="bZipCode"
            type="text"
            name="bZipCode"
          />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('bZipCode')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('bZipCode') && touched.businessAddress.zipCode" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100" @click="focus('bCountry')">
        <md-field
          :class="[
            { 'md-valid': !errors.has('bCountry') && touched.businessAddress.country },
            { 'md-form-group': false },
            { 'md-error': errors.has('bCountry') }
          ]"
        >
          <md-icon>outlined_flag</md-icon>
          <label>Country</label>
          <md-select
            v-validate="'required'"
            id="country-select"
            ref="countryInput"
            v-model="bCountry"
            data-vv-name="bCountry"
            type="text"
            name="bCountry"
            md-dense
          >
            <md-option v-for="(country, index) in countries" :key="index" :value="country.LookupId" :id="country"
              >{{ country.DisplayValue }}
            </md-option>
          </md-select>
          <slide-y-down-transition>
            <md-icon v-show="errors.has('bCountry')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('bCountry') && touched.businessAddress.country" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div :class="[{ 'md-layout-item': true }, { 'md-size-70': isPhone }, { 'md-size-100': !isPhone }]">
        <md-field
          :class="[
            { 'md-valid': !errors.has('businessPhone') && touched.businessPhone },
            { 'md-form-group': true },
            { 'md-error': errors.has('businessPhone') }
          ]"
        >
          <md-icon>phone</md-icon>
          <label class="spaced-phone-label">Business Phone</label>
          <md-input
            v-mask="'(###) ###-####'"
            v-validate="{ required: true, min: 10 }"
            ref="businessPhone"
            v-model="businessPhone"
            data-vv-name="businessPhone"
            class="dense-phone-input"
            type="text"
            name="businessPhone"
          />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('businessPhone')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('businessPhone') && touched.businessPhone" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- WEBSITE -->
      <div :class="[{ 'md-layout-item': true }, { 'md-size-70': isPhone }, { 'md-size-100': !isPhone }]">
        <md-field
          :class="[
            { 'md-valid': !errors.has('website') && touched.website },
            { 'md-form-group': false },
            { 'md-error': errors.has('website') }
          ]"
        >
          <md-icon>location_city</md-icon>
          <label>Web Address</label>
          <md-input v-validate="'url'" v-model="website" data-vv-name="website" type="text" name="website" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('website')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('website') && touched.website" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { SlideYDownTransition } from "vue2-transitions"
import $ from "jquery"

export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      website: "",
      stateFilterKeys: "",
      mAddress1: "",
      mAddress2: "",
      mCity: "",
      mState: null,
      mCountry: null,
      mZipCode: "",
      bAddress1: "",
      bAddress2: "",
      bCity: "",
      bState: null,
      bCountry: null,
      bZipCode: "",
      businessPhone: "",
      states: [],
      countries: [],
      touched: {
        mailingAddress: {
          address1: false,
          address2: false,
          city: false,
          state: false,
          country: false,
          zipCode: false
        },
        businessAddress: {
          address1: false,
          address2: false,
          city: false,
          state: false,
          country: false,
          zipCode: false,
          website: false
        },
        businessPhone: false
      }
    }
  },
  watch: {
    mAddress1() {
      this.touched.mailingAddress.address1 = true
    },
    mAddress2() {
      this.touched.mailingAddress.address2 = true
    },
    mCity() {
      this.touched.mailingAddress.city = true
    },
    mState() {
      this.touched.mailingAddress.state = true
    },
    mCountry() {
      this.touched.mailingAddress.country = true
    },
    mZipCode() {
      this.touched.mailingAddress.zipCode = true
    },
    bAddress1() {
      this.touched.businessAddress.address1 = true
    },
    bAddress2() {
      this.touched.businessAddress.address2 = true
    },
    bCity() {
      this.touched.businessAddress.city = true
    },
    bState() {
      this.touched.businessAddress.state = true
    },
    bCountry() {
      this.touched.businessAddress.country = true
    },
    bZipCode() {
      this.touched.businessAddress.zipCode = true
    },
    businessPhone() {
      this.touched.businessPhone = true
    },
    website() {
      this.touched.website = true
    }
  },
  computed: {
    ...mapGetters(["rdBillingAddress", "rdMailingAddress", "isPhone", "rdPersonal"])
  },
  mounted() {
    this.defineLookups()
  },
  methods: {
    ...mapActions(["listLookupsByMasterName"]),
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    stateFind(event) {
      if (event.key === "Escape") {
        this.stateFilterKeys = ""
      }
      if (event.key === "Enter") {
        this.reRenderState()
        this.$refs.zipCodeInput.$el.focus()
      }
      if (event.key.length > 1) return
      if (this.stateFilterKeys.length < 2) {
        this.stateFilterKeys += event.key.toUpperCase()
      } else {
        this.stateFilterKeys = event.key.toUpperCase()
      }
      let foundState = this.states.find((state) => {
        return state.startsWith(this.stateFilterKeys)
      })
      if (!foundState) {
        this.stateFilterKeys = ""
        return
      }
      this.state = foundState
      let value = this.states.indexOf(foundState) * 43
      let stateID = $("#" + foundState + "-state")
      let scrollParent = $(stateID).parent().parent()
      $(scrollParent).scrollTop(value)
    },
    focus(type) {
      let el = $("#" + type + "-select")
      el.focus()
    },
    fetchLookupByName(name) {
      return this.listLookupsByMasterName(name)
    },
    idToLookup(lookupList, id) {
      let lookupItem = lookupList.find((item) => item.LookupId === +id)
      if (lookupItem) {
        return lookupItem.LookupId
      } else {
        return null
      }
    },
    async defineLookups() {
      try {
        this.states = await this.fetchLookupByName("States")
        this.countries = await this.fetchLookupByName("CountryCodes")
        if (this.isEdit) {
          this.fillAddressData()
        }
      } catch (error) {
        console.error(error)
      }
    },
    fillAddressData() {
      this.mAddress1 = this.rdMailingAddress.address1 || ""
      this.mAddress2 = this.rdMailingAddress.address2 || ""
      this.mCity = this.rdMailingAddress.city || ""
      this.mState = this.idToLookup(this.states, this.rdMailingAddress.state) || ""
      this.mCountry = this.idToLookup(this.countries, this.rdMailingAddress.country) || ""
      this.mZipCode = this.rdMailingAddress.zipCode || ""

      this.bAddress1 = this.rdBillingAddress.address1 || ""
      this.bAddress2 = this.rdBillingAddress.address2 || ""
      this.bCity = this.rdBillingAddress.city || ""
      this.bState = this.idToLookup(this.states, this.rdBillingAddress.state) || ""
      this.bCountry = this.idToLookup(this.countries, this.rdBillingAddress.country) || ""
      this.bZipCode = this.rdBillingAddress.zipCode || ""

      this.website = this.rdPersonal.website
      this.businessPhone = this.rdBillingAddress.businessPhone || ""
    },
    storeValues() {
      this.rdBillingAddress.address1 = this.bAddress1
      this.rdBillingAddress.address2 = this.bAddress2
      this.rdBillingAddress.city = this.bCity
      this.rdBillingAddress.state = this.bState
      this.rdBillingAddress.country = this.bCountry
      this.rdBillingAddress.zipCode = this.bZipCode
      this.rdBillingAddress.website = this.website

      this.rdMailingAddress.address1 = this.mAddress1
      this.rdMailingAddress.address2 = this.mAddress2
      this.rdMailingAddress.city = this.mCity
      this.rdMailingAddress.state = this.mState
      this.rdMailingAddress.country = this.mCountry
      this.rdMailingAddress.zipCode = this.mZipCode
      this.rdMailingAddress.phone = this.mPhone

      this.rdBillingAddress.businessPhone = this.businessPhone
    },
    validate() {
      this.storeValues()
      return this.$validator.validateAll().then((res) => {
        if (res) {
          this.$emit("on-validated", res)
        }
        return res
      })
    }
  }
}
</script>

<style>
.md-divider {
  background-color: #ddd;
  height: 2px;
  width: 100%;
  margin: 20px 0;
}
h3 {
  font-size: 18px;
  margin-bottom: 10px;
}
</style>
